import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { useThemeColors } from "../../Context/Theme";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import ProductCard from "../../components/ProuctCard";
import offerImage from "../../Images/T-Shirt-img.png";
import ageImage from "../../Images/21yrold.png";
import API_URL from "../../ServiceModule/Service";
import { BLACK, PRIMARY } from "../../styles/color";
import {
  addToCart,
  removeFromCart,
  removeItemFromCart,
} from "../../Features/services/cartSlice";
import { useDispatch } from "react-redux";
import {
  useGetAPIWithoutTokenQuery,
  usePostAddToCartWithTokenMutation,
  usePostAPIWithTokenMutation,
  useRemoveFromCartWithTokenMutation,
} from "../../Api/api";
import { ADD_TO_CART, REMOVE_FROM_CART } from "../../Api/apiConstant";
import debounce from "lodash.debounce";
import { getEventName } from "../../Utils/sessionutility";
import { isMobile } from "../../global/helpers";
import { getLoggedIn, getToken, getUserId } from "../../LoginModule/LoginUtility";

const TrendingProducts = ({ eventName }) => {
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    buttonTextColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors();
  const navigate = useNavigate();
  const [categoryProductData, setCategoryProductData] = useState({});
  const [selectedSku, setSelectedSku] = useState({});
  const [selectedSkuid, setSelectedSkuid] = useState({});
  const eventId = sessionStorage.getItem("event_id");
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const userId = getUserId();
  const token = getToken()
  const cartId = sessionStorage.getItem("cartId");
  const cartItem = useSelector((state) => state.cart.items);
  const [blankQuantitySku, setBlankQuantitySku] = useState([])
  const [selectedSkuQuantity, setSelctedSkuQuantity] = useState([])
  const [AddToCart] = usePostAddToCartWithTokenMutation();
  const [RemoveFromCart] = useRemoveFromCartWithTokenMutation();
  const [Removecart] = useRemoveFromCartWithTokenMutation();

  const offerData = useSelector((state) => state.offer.value);

  const isLoggedIn = getLoggedIn();

  const handleSeeAll = (categoryId) => {
    navigate(`/events/${eventName}/shop`, { state: { category: categoryId } });
  };

  const fetchProductsByCategory = async (categoryId) => {
    try {
      const response = await axios.get(
        `${API_URL}/api/offer/getOfferEventCategoryById?event_id=${eventId}&category_id=${categoryId}`
      );
      return response.data.slice(0, 3);
    } catch (err) {
      console.error("Error fetching products:", err);
      return [];
    }
  };

  const fetchProductsForAllCategories = async () => {
    try {
      const categoryData = {};

      await Promise.all(
        offerData.flat(1).map(async (offer) => {
          const categoryId = offer?.category?.category_id;
          if (categoryId && !categoryProductData[categoryId]) {
            const data = await fetchProductsByCategory(categoryId);
            categoryData[categoryId] = data;
          }
        })
      );

      setCategoryProductData(categoryData);
    } catch (error) {
      console.error("Error fetching products for categories:", error);
    }
  };

  useEffect(() => {
    if (eventId && offerData.length) {
      setCategoryProductData({});
      fetchProductsForAllCategories();
    }

    return () => {
      setCategoryProductData({});
    };
  }, [eventId, offerData]);

  const exceptSoftDrinks = offerData.flat(1);

  const exceptSoftDrinksUnique = Array.from(
    new Set(exceptSoftDrinks.map((item) => item?.category?.category_id))
  ).map((id) =>
    exceptSoftDrinks.find((item) => item?.category?.category_id === id)
  );

  const handleUnitSelect = (product, skuId) => {
    try {
      const selectedSku = product?.skus.find((sku) => sku?.sku_id === skuId);
      if (selectedSku) {
        setSelectedSku((prevSelectedSku) => ({
          ...prevSelectedSku,
          [product.product_id]: selectedSku,
        }));
      }
    } catch (error) {

    }
  };

  const handleChangeQuantity = async (value, product) => {
    const selectedSkuData = selectedSku[product.product_id] || product?.skus?.filter(i => i.sku_status === 1)?.[0];
    if (value === "") {
      setSelctedSkuQuantity(selectedSkuQuantity.filter(n => n.skuId !== selectedSkuData.sku_id))
      setBlankQuantitySku(prev => [...prev, selectedSkuData.sku_id])
      debouncedRemoveFromCart(product, 0)
      return;
    }
    if(value === 0){
      debouncedRemoveFromCart(product, 0)
    }
    {
      const currentDate = new Date();
      const preorderStartDate = new Date(
        sessionStorage.getItem("preorderStartDate")
      );
      const preorderEndDate = new Date(
        sessionStorage.getItem("preorderEndDate")
      );
      preorderStartDate.setUTCHours(0, 0, 0, 0);
      preorderEndDate.setUTCHours(23, 59, 59, 999);
      if (currentDate < preorderStartDate) {
        toast.error("Pre-order has not started yet.");
        return;
      } else if (currentDate > preorderEndDate) {
        toast.error(
          "The pre-order period has expired. You can't place an order."
        );
        return;
      }
    }
    // Create the new cart item with the desired structure
    setBlankQuantitySku(blankQuantitySku.filter(i => i !== selectedSkuData.sku_id))
    setSelctedSkuQuantity(prev => {
      // Remove any previous entries with the same skuId
      const filtered = prev.filter(item => item.skuId !== selectedSkuData.sku_id);
      // Add the new one at the end
      return [...filtered, { skuId: selectedSkuData.sku_id, quantity: value }];
    });
    const newCartItem = {
      product_id: product.product_id,
      sku_id: selectedSkuData?.sku_id,
      quantity: value,
      price: selectedSkuData?.discount_price || selectedSkuData?.regular_price,
      total_price: (
        (selectedSkuData?.discount_price || selectedSkuData?.regular_price) *
        (selectedSkuData?.quantity ? selectedSkuData.quantity + 1 : 1)
      ).toFixed(2),
      user_id: userId,
      event_id: eventId,
      status: "active",
      created_date: null,
      product_details: {
        product_id: product.product_id,
        product_name: product.product_name,
        product_description: product.product_description,
        state_tax: product.state_tax || "0.00",
        city_tax: product.city_tax || "0.00",
        brands: product.brands || [],
        categories: product.categories || [],
        productImg: product.productImg || [],
        skus: [selectedSkuData],
        categoryTax: product.categoryTax || [],
      },
    };
    const existingCartItem = cartItem.find(
      (item) =>
        item.product_id === newCartItem.product_id &&
        item.sku_id === newCartItem.sku_id
    );

    if (existingCartItem) {
      // Update quantity and total price for an existing item
      newCartItem.quantity = value;
      newCartItem.total_price = (newCartItem.quantity * parseFloat(newCartItem.price)).toFixed(2);
    }

    // Redirect to login if the user is not logged in
    if (!isLoggedIn) {
      return navigate(`/events/${eventName}/login`);
    }

    try {
      // Dispatch the new cart item to Redux store
      // dispatch(
      //   addToCart({
      //     ...newCartItem,
      //   })
      // );
      // Make API call to add the item to the backend cart
      const { data } = await AddToCart({
        url: ADD_TO_CART,
        formData: {
          user_id: userId,
          items: [
            {
              product_id: newCartItem.product_id,
              sku_id: newCartItem.sku_id,
              quantity: newCartItem.quantity,
              price: newCartItem.price,
              total_price: newCartItem.total_price,
            },
          ],
          event_id: eventId,
        },
        token,
      });

      if (data.message === "Cart and CartItems processed successfully") {
        sessionStorage.setItem("cartId", data?.cart_id);
      }
    } catch (error) {
      console.error("Add to cart error:", error);
    }
  }

  const handleAddToCart = async (product) => {
    const selectedSkuData = selectedSku[product.product_id] || product?.skus[0];
    setSelctedSkuQuantity(selectedSkuQuantity.filter(n => n.skuId !== selectedSkuData.sku_id))
    setBlankQuantitySku(blankQuantitySku.filter(i => i !== selectedSkuData.sku_id))
    const newCartItem = {
      product_id: product.product_id,
      sku_id: selectedSkuData?.sku_id,
      quantity: selectedSkuData?.quantity ? selectedSkuData.quantity + 1 : 1,
      price: selectedSkuData?.discount_price || selectedSkuData?.regular_price,
    };

    const existingCartItem = cartItem.find(
      (item) =>
        item.product_id === newCartItem.product_id &&
        item.sku_id === newCartItem.sku_id
    );

    if (existingCartItem) {
      newCartItem.quantity = existingCartItem?.quantity + 1;
    }

    if (!isLoggedIn) {
      return navigate(`/events/${eventName}/login`);
    }

    dispatch(addToCart({ ...product, quantity: newCartItem.quantity }));

    try {
      const { data } = await AddToCart({
        url: ADD_TO_CART,
        formData: {
          user_id: userId,
          items: [newCartItem],
          event_id: eventId,
        },
        token,
      });

      if (data.message === "Cart and CartItems processed successfully") {
        sessionStorage.setItem("cartId", data.cart_id);
      }
    } catch (error) {
      console.error("Add to cart error:", error);
    }
  };

  const handleRemoveFromCart = async (product, value) => {
    const isSelectedSkuEmpty =
      !selectedSku || Object.keys(selectedSku).length === 0;

    const selectedSkuId = isSelectedSkuEmpty
      ? product?.skus?.[0]?.sku_id
      : selectedSku[product?.product_id]?.sku_id;

    if (value !== 0) {
      setSelctedSkuQuantity(selectedSkuQuantity.filter(n => n.skuId !== selectedSkuId))
      setBlankQuantitySku(blankQuantitySku.filter(i => i !== selectedSkuId))
    }

    const selectedProduct = isSelectedSkuEmpty
      ? { ...product, skus: [product?.skus[0]?.skus?.[0]] }
      : { ...product, skus: [selectedSku[product?.product_id]] };

    const existingCartItem = cartItem?.find((item) => {

      return (
        item.product_id === selectedProduct?.product_id &&
        item.sku_id === selectedSkuId
      );
    });

    if (!existingCartItem) {
      console.warn("Product not found in cart.");
      return;
    }

    const newQuantity = value === 0 ? value : existingCartItem.quantity - 1
    const newCartItem = {
      product_id: existingCartItem?.product_id,
      sku_id: existingCartItem?.sku_id,
      quantity: Math.max(newQuantity, 0),
      bundle_id: existingCartItem.bundle_id,
      price:
        existingCartItem?.product_details?.skus[0]?.discount_price ||
        existingCartItem?.product_details?.skus[0]?.regular_price,
    };

    try {
      if (newQuantity > 0) {
        dispatch(removeFromCart({ ...product, quantity: newQuantity }));

        await Removecart({
          url: ADD_TO_CART,
          formData: {
            user_id: userId,
            items: [newCartItem],
            event_id: eventId,
            callFrom: 'Remove'
          },
          token,
        });
      } else {
        dispatch(removeItemFromCart({ itemId: existingCartItem.product_id }));
        await RemoveFromCart({
          url: REMOVE_FROM_CART,
          formData: {
            cart_id: cartId,
            product_id: existingCartItem?.product_id,
            sku_id: existingCartItem?.sku_id,
            event_id: eventId,
          },
          token,
        });
      }
    } catch (error) {
      console.error("Error while removing from cart:", error);
    }
  };

  const debouncedAddToCart = debounce(handleAddToCart, 300);
  const debouncedRemoveFromCart = debounce(handleRemoveFromCart, 300);

  return (
    <div>
      {exceptSoftDrinksUnique.map((offer, index) => {
        const categoryId = offer?.category?.category_id;

        if (!categoryId) return null;

        const products = categoryProductData[categoryId] || [];

        return (
          <div
            className="event-container fo_css_event_trending_product_container"
            key={categoryId}
            style={eventContainerStyle}
          >
            <div className="d-flex justify-content-between">
              <p
                style={{
                  fontSize: fontSizeHeading || "30px",
                  fontWeight: fontWeightHeading || "700",
                  color: textColor || "black",
                  fontFamily: fontFamilyHeading
                }}
              >
                {offer?.category?.category_name}
              </p>
              <p
                onClick={() => handleSeeAll(categoryId)}
                style={{
                  fontSize: fontSizeHeading || "20px",
                  fontWeight: fontWeightHeading || "400",
                  color: primaryColor || PRIMARY,
                  cursor: "pointer",
                  fontFamily: fontFamilyHeading
                }}
              >
                See all
              </p>
            </div>

            <Grid
              container
              spacing={4}
              justifyContent="flex-start"
              className="fo_css_event_trending_product_content"
              style={isMobile() ? {} : { paddingLeft: "1vw" }}
            >
              <Grid item xs={12} md={3} style={isMobile() ? { height: '40vh' } : {}}>
                <div
                  style={bannerStyle}
                  onClick={() => handleSeeAll(categoryId)}
                >
                  <p style={{ ...descriptionStyle, fontFamily, fontWeight }}>
                    {exceptSoftDrinks[index]?.discription}
                  </p>

                  <div
                    className="orderButton"
                    style={{
                      backgroundColor: buttonColor || PRIMARY,
                      color: buttonTextColor,
                    }}
                  >
                    <p style={{ ...orderButtonStyle, fontFamily, fontWeight }}>Order Now</p>
                  </div>
                  {/* <img
                    src={
                      exceptSoftDrinks[index]?.category?.products?.[
                        exceptSoftDrinks[index]?.category?.products?.length - 1
                      ]?.productImg?.[0]?.product_img
                    }
                    style={bannerImageStyle}
                    alt="Product"
                  /> */}
                  <img
                    src={exceptSoftDrinks[index]?.offer_img_path}
                    style={isMobile() ? {
                      width: "90%",
                      maxHeight: "20vh",
                      objectFit: "contain",
                    } : bannerImageStyle}
                    alt="Product"
                  />
                </div>
              </Grid>

              {
                isMobile() ?
                  <div style={isMobile() ?
                    { display: "flex", flexDirection: 'column', justifyContent: 'center', margin: '20px auto' }
                    : {}}>
                    {products.map((product) => {
                      const selectedProduct = { ...product, skus: selectedSkuid };
                      return (
                        <ProductCard
                          offer={product?.offer}
                          ageRestriction={
                            product?.categories[0]?.age_validation === "21"
                          }
                          productName={product?.product_name}
                          productType={product?.categories[0]?.category_name}
                          categoryId={product?.categories[0]?.category_id}
                          sku={product?.skus}
                          price={
                            selectedSku[product?.product_id]?.regular_price ||
                            product?.skus[0]?.regular_price
                          }
                          discount={
                            selectedSku[product.product_id]?.discount_price ||
                            product?.skus[0]?.discount_price
                          }
                          offerDiscount={
                            selectedSku[product.product_id]?.discount_amount ||
                            product?.skus[0]?.discount_amount
                          }
                          product={product}
                          productId={product?.product_id}
                          image={product?.productImg?.[0]?.product_img}
                          rating={product?.rating || 4}
                          buttonText="Add"
                          onClick={() => debouncedAddToCart(product)}
                          offerImage={offerImage}
                          addQuantity={() => debouncedAddToCart(product)}
                          removeQuantity={() => debouncedRemoveFromCart(product)}
                          onUnitSelect={(prod, skuID) =>
                            handleUnitSelect(prod, skuID)
                          }
                          handleChangeQuantity={handleChangeQuantity}
                          blankQuantitySku={blankQuantitySku}
                          selectedSkuQuantity={selectedSkuQuantity}
                          style={isMobile() ?
                            {
                              marginLeft: "1em",
                              marginBottom: '10px',
                              width: '300px'
                            } : {
                              marginLeft: "1em",
                            }}
                          imageStyle={isMobile() ? {
                            width: "90%",
                            height: 'unset'
                          } : {}}
                        />
                      );
                    })}
                  </div> : <>
                    {products.map((product) => {
                      const selectedProduct = { ...product, skus: selectedSkuid };
                      return (
                        <ProductCard
                          offer={product?.offer}
                          ageRestriction={
                            product?.categories[0]?.age_validation === "21"
                          }
                          productName={product?.product_name}
                          productType={product?.categories[0]?.category_name}
                          categoryId={product?.categories[0]?.category_id}
                          sku={product?.skus}
                          price={
                            selectedSku[product?.product_id]?.regular_price ||
                            product?.skus[0]?.regular_price
                          }
                          discount={
                            selectedSku[product.product_id]?.discount_price ||
                            product?.skus[0]?.discount_price
                          }
                          offerDiscount={
                            selectedSku[product.product_id]?.discount_amount ||
                            product?.skus[0]?.discount_amount
                          }
                          product={product}
                          productId={product?.product_id}
                          image={product?.productImg?.[0]?.product_img}
                          rating={product?.rating || 4}
                          buttonText="Add"
                          onClick={() => debouncedAddToCart(product)}
                          offerImage={offerImage}
                          addQuantity={() => debouncedAddToCart(product)}
                          removeQuantity={() => debouncedRemoveFromCart(product)}
                          onUnitSelect={(prod, skuID) =>
                            handleUnitSelect(prod, skuID)
                          }
                          handleChangeQuantity={handleChangeQuantity}
                          blankQuantitySku={blankQuantitySku}
                          selectedSkuQuantity={selectedSkuQuantity}
                          style={isMobile() ?
                            {
                              marginLeft: "1em",
                              marginBottom: '10px',
                              width: '300px'
                            } : {
                              marginLeft: "1em",
                            }}
                          imageStyle={isMobile() ? {
                            width: "90%",
                            height: 'unset'
                          } : {}}

                        />
                      );
                    })}
                  </>}
            </Grid>
          </div>
        );
      })}
    </div>
  );
};

const eventContainerStyle = {
  border: "2px solid #E9E9E9",
  margin: "20px auto",
  maxWidth: "90%",
  borderRadius: "25px",
  padding: "29px",
  backgroundColor: "#FAFAFA",
};

const titleStyle = {
  fontSize: "30px",
  fontWeight: "700",
};

const seeAllStyle = {
  fontSize: "20px",
  fontWeight: "400",
  color: PRIMARY,
  cursor: "pointer",
};

const bannerStyle = {
  backgroundImage: `url(${require("../../Images/blueBG.png")})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  borderRadius: "21px",
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  alignItems: "center",
  cursor: "pointer",
};

const descriptionStyle = {
  textAlign: "center",
  fontWeight: 600,
  padding: "0px 2vw",
};

const orderButtonStyle = {
  height: "100%",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const bannerImageStyle = {
  height: "30%",
  width: "30%",
  objectFit: "contain",
};

export default React.memo(TrendingProducts);





























































































































































































































































































































































































